import Button, { ButtonProps } from "~/components/Button";
import { AlertDialog } from "../AlertDialog";
import Icon from "~/assets/icons/Icon";
import { useRouter } from "next/router";
import classNames from "classnames";

type Props = {
  buttonText?: string;
  confirmText?: string;
  bodyText?: string;
  backPath?: string;
  hideIcon?: boolean;
  variant?: ButtonProps["variant"];
  className?: string;
  requiresConfirmation?: boolean;
};

export const CloseDialog = ({
  buttonText,
  confirmText,
  bodyText,
  backPath,
  hideIcon,
  variant,
  className,
  requiresConfirmation,
}: Props) => {
  const router = useRouter();

  const onClick = () => {
    if (backPath) return router.push(backPath);

    router.back();
  };

  if (requiresConfirmation)
    return (
      <AlertDialog
        trigger={
          <Button
            variant={variant ?? "primary-dark"}
            size="lg"
            className={classNames(
              "flex items-center gap-2.5 justify-center",
              className
            )}
          >
            {buttonText ?? "Luk"}
            {!hideIcon && <Icon name="close" className="w-6 h-6" />}
          </Button>
        }
        iconName="warning"
      >
        <h4 className="text-secondary-800 m-0 text-xl font-medium mb-5 text-center">
          {bodyText ?? "Har du husket at gemme?"}
        </h4>
        <div className="flex gap-5 mt-10">
          <AlertDialog.Cancel className="grow">Tilbage</AlertDialog.Cancel>

          <AlertDialog.Ok className="grow" onClick={onClick}>
            {confirmText ?? "Luk"}
          </AlertDialog.Ok>
        </div>
      </AlertDialog>
    );

  return (
    <Button
      variant={variant ?? "primary-dark"}
      size="lg"
      className={classNames(
        "flex items-center gap-2.5 justify-center",
        className
      )}
      onClick={onClick}
    >
      {buttonText ?? "Luk"}
      {!hideIcon && <Icon name="close" className="w-6 h-6" />}
    </Button>
  );
};
